'use client'
import { createStoreState } from '../internalImplementation/utils/createStoreState/createStoreState.js';

const { getWalletConnectorOptions, setWalletConnectorOptions, useWalletConnectorOptions, resetWalletConnectorOptions, } = createStoreState('walletConnectorOptions');

export { getWalletConnectorOptions, resetWalletConnectorOptions, setWalletConnectorOptions, useWalletConnectorOptions };
